import CustomInput from "../../../components/CustomInput";
import { Student } from "../../../types/studentType";
import { IS_LIVE } from "../../../util/config/env";

export default function StudentOtherDetails({
  data,
  onChange,
}: {
  data: Partial<Student>;
  onChange: any;
}) {
  return (
    <div className="grid gap-6">
      <div className="grid md:grid-cols-2 gap-6">
        {IS_LIVE && (
          <>
            <CustomInput
              name="bloodGroup"
              label="Blood Group"
              placeholder="Ex: O+"
              value={data.bloodGroup ?? ""}
              onChange={onChange}
            />
            <CustomInput
              name="allergies"
              label="Allergies"
              placeholder="Please mention Allergies (if any)"
              value={data.allergies ?? ""}
              onChange={onChange}
            />
          </>
        )}
        <CustomInput
          name="nationality"
          label="Nationality"
          placeholder="Enter nationality"
          value={data.nationality ?? ""}
          onChange={onChange}
        />

        <CustomInput
          name="specialInstructions"
          label="Special Instructions"
          placeholder="Please mention any specific instructions for your child"
          value={data.specialInstructions ?? ""}
          onChange={onChange}
        />
      </div>

      <div>
        <label className="font-semibold text-sm">
          Transport facility required?
        </label>
        <div className="flex gap-4 mt-2">
          <label>
            <input
              type="radio"
              name="transportRequired"
              value="true"
              checked={data.transportRequired === true}
              onChange={onChange}
            />{" "}
            Yes
          </label>

          <label>
            <input
              type="radio"
              name="transportRequired"
              value="false"
              checked={data.transportRequired === false}
              onChange={onChange}
            />{" "}
            No
          </label>
        </div>
      </div>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          name="termsAccepted"
          checked={!!data.termsAccepted}
          onChange={onChange}
          className="w-3 h-3"
        />
        I agree to the terms and conditions of the school
      </label>
    </div>
  );
}
